import { ENV, EDID_FIRMWARE_REVISION, RPC_FIRMWARE_REVISION, NEW_ADMIN_URL } from 'environment';
import './boxcaster_form_controller';
import './boxcaster_inventory_form_controller';
import './boxcaster_register_form_controller';
import Edid from '../../utils/edid'
import { ParseSupportedBoxCastResolutions } from '../../utils/boxcast-edid';

const BOXCASTER_PRO_INCLUDED_PLAN_ID = 'essential:annual';
const BOXCASTER_HDSD2_INCLUDED_PLAN_ID = 'free-social-streaming:annual';

angular
.module('app.views')
  .config(($routeProvider) => {
      $routeProvider.when('/boxcasters/:id', {
          template: require('./boxcaster.html'),
          controller: 'BoxcasterController'
      });
  })
.controller('BoxcasterController', function(ActivationCodes, $scope, $routeParams, $window, $log, $modal, Boxcaster, Config, RPC){
  $scope.config = Config;
  $scope.newAdminURL = NEW_ADMIN_URL;
  $scope.backhaulProtocols = Config.boxcaster.backhaul_protocols;

  $scope.$on('$destroy', () => RPC.cancelAll());

  const onBoxCasterFetchSuccess = function() {
    if ($scope.hasRpc($scope.boxcaster) && $scope.isOnline($scope.boxcaster)) {
      if ($scope.platformoptKey) {
        RPC.call($scope.boxcasterId, {request: {message: 'get_key', key: $scope.platformoptKey}}).then(function(data){
          if (data.error != null) {
            $log.error(data);
            return $window.alert("There was an error processing the get_key RPC. Check the console for more details.");
          } else {
            return $scope.platformOption = data;
          }
        });
      }
      if ($scope.enforcecertsKey) {
        $scope.certRpcInFlight = true;
        RPC.call($scope.boxcasterId, {request: {message: 'get_key', key: $scope.enforcecertsKey}}).then(function(data){
          if (data.error != null) {
            $log.error(data);
            return $window.alert("There was an error processing the get_key RPC. Check the console for more details.");
          } else {
            $scope.certRpcInFlight = false;
            return $scope.certificateVerification = $scope.interpretCertValue(data);
          }
        });
      }
    }
  };

  $scope.boxcasterId = $routeParams.id;
  $scope.platformoptKey = null;
  $scope.enforcecertsKey = null;
  if (/^[pv][a-f0-9]{12}$/.test($scope.boxcasterId)) {
    $scope.platformoptKey = 'platformopt';
    $scope.enforcecertsKey = 'enforcecerts';
  } else if (/^[l-o][a-f0-9]{12}$/.test($scope.boxcasterId)) {
    $scope.platformoptKey = 'uboot.platformopt';
    $scope.enforcecertsKey = 'uboot.enforcecerts';
  }
  $scope.boxcaster = Boxcaster.get({id: $routeParams.id}, onBoxCasterFetchSuccess);
  $scope.activation = ActivationCodes.getSafe({id: $routeParams.id})
  $scope.manifestCollapsed = true;
  $scope.isRebooting = false;
  $scope.hdmiOutputEdidExpanded = false;
  $scope.wirelessExpanded = false;

  $scope.boxcasterLogsUrl = boxcaster=> `https://app.datadoghq.com/dashboard/zem-zn4-p8d/boxcaster?live=true&tpl_var_boxcaster_id=${boxcaster.id}&tpl_var_env=${ENV}`;

  $scope.canUnregister = boxcaster=> ['ready', 'preparing_broadcast', 'broadcasting', 'offline'].includes(boxcaster.status);

  $scope.canRegister = boxcaster=> !boxcaster.account_id;

  $scope.canEdit = boxcaster=> $scope.canRegister(boxcaster) || $scope.canUnregister(boxcaster);

  $scope.unregister = function(boxcaster){
    if (confirm('Are you sure you want to unregister this boxcaster?')) {
      return Boxcaster.update({id: boxcaster.id, account_id: ''} , data=> $scope.boxcaster = data);
    }
  };

  $scope.register = (boxcaster) => {
    $modal.open({template: require('./boxcaster_register_form.html'), controller: 'BoxcasterRegisterFormController', size: 'lg', backdrop: 'static'}).result.then(b=> $scope.boxcaster = b);
  }

  $scope.makeActivation = (boxcaster) => {
    if (!confirm('Please confirm that this BoxCaster will be sold through distribution. This will create an activation code entry.')) {
      return;
    }
    var stripe_plan;
    if (boxcaster.id.startsWith('p')) {
      stripe_plan = BOXCASTER_PRO_INCLUDED_PLAN_ID;
    } else {
      stripe_plan = BOXCASTER_HDSD2_INCLUDED_PLAN_ID;
    }
    ActivationCodes.create({
      boxcaster_id: boxcaster.id,
      num_codes: 1,
      stripe_plan: stripe_plan,
      status: 'distributed',
    }).$promise.then((res) => {
      $scope.activation = ActivationCodes.getSafe({id: $routeParams.id})
    });
  }

  $scope.isOnline = boxcaster=> ['ready', 'preparing_broadcast', 'broadcasting'].includes(boxcaster.status);

  $scope.isPro = boxcaster => (boxcaster != null) && (boxcaster.id != null) && (/^p/.test(boxcaster.id));

  $scope.isVision = boxcaster => (boxcaster != null) && (boxcaster.id != null) && (/^v/.test(boxcaster.id));

  $scope.isReady = boxcaster=> boxcaster.status === 'ready';

  $scope.reboot = function(boxcaster){
    if (confirm('Are you sure you want to reboot this boxcaster?')) {
      $scope.isRebooting = true;
      return RPC.call($scope.boxcasterId, {request: 'reboot'}).then(function(data){
        if (data.error != null) {
          $log.error(data);
          return $window.alert("There was an error processing the reboot RPC. Check the console for more details.");
        } else {
          return $scope.isRebooting = false;
        }
      });
    }
  };

  $scope.interpretCertValue = function(data) {
    if (/^[pv][a-f0-9]{12}$/.test($scope.boxcasterId)) {
      if ((data.value === null) || (data.value === undefined) || (data.value === true) || (/true/i.test(data.value))) {
        return 'set';
      } else {
        return 'not set';
      }
    } else {
      if ((data.value === true) || (/true/i.test(data.value))) {
        return 'set';
      } else {
        return 'not set';
      }
    }
  };

  $scope.toggleCertVerification = function(boxcaster, certVerification){
    const existingStatus = (certVerification == 'set');
    const aboutTo = existingStatus ? 'disable' : 'enable';
    let newValue;
    if (/^[pv][a-f0-9]{12}$/.test($scope.boxcasterId)) {
      newValue = !existingStatus;
    } else {
      newValue = (existingStatus ? null : 'true');
    }
    if (confirm(`Are you sure you want to ${aboutTo} SSL certification verification for this boxcaster?`)) {
      $scope.certRpcInFlight = true;
      return RPC.call($scope.boxcasterId, {request: {message: 'set_key', key: $scope.enforcecertsKey, value: newValue}}).then(function(data){
        if (data.error != null) {
          $log.error(data);
          return $window.alert("There was an error processing the set_key RPC. Check the console for more details.");
        } else {
          $scope.certRpcInFlight = false;
          return $scope.certificateVerification = $scope.interpretCertValue(data);
        }
      });
    }
  };

  $scope.loadHdmiOutputEdid = function() {
    $scope.edidRpcInFlight = true;
    RPC.call($scope.boxcasterId, {request: 'get_hdmi_out_edid'}).then(data =>{
      if (data.error != null) {
        if (data.error === 'no_output') {
          $scope.edidError = "No HDMI output present, or EDID could not be loaded.";
        } else {
          $log.error(data);
          $scope.edidError = "Error loading EDID! Check the console for more details.";
        }
      } else {
        $scope.edid = new Edid(Uint8Array.from(atob(data), c => c.charCodeAt(0)));
        $scope.edid.supportedBoxCastResolutions = ParseSupportedBoxCastResolutions($scope.edid);
      }
      $scope.edidRpcInFlight = false;
    }, error => {
      $log.error(data);
      $scope.edidError = "Error loading EDID! Check the console for more details.";
      $scope.edidRpcInFlight = false;
    });
  }

  $scope.reloadHdmiOutputEdid = function() {
    $scope.edid = null;
    $scope.edidError = null;
    $scope.hdmiOutputEdidExpanded = true;
    $scope.loadHdmiOutputEdid();
  }

  $scope.toggleHdmiOutputEdidExpanded = function() {
    if (!$scope.hdmiOutputEdidExpanded && !$scope.edid && !$scope.edidError && !$scope.edidRpcInFlight) {
      $scope.loadHdmiOutputEdid();
    }
    $scope.hdmiOutputEdidExpanded = !$scope.hdmiOutputEdidExpanded;
  }

  $scope.loadWireless = function() {
    $scope.wifiConfigInFlight = true;
    RPC.call($scope.boxcasterId, {request: 'get_wifi_config'}).then(data => {
      data.scan_results = $scope.reduceScanResults(data.scan_results);
      $scope.wifiConfig = data;
      $scope.wifiConfigInFlight = false;
    }, error => {
      $log.error(data);
      $scope.wifiConfig = {"error": data};
      $scope.wifiConfigInFlight = false;
    });
  }

  $scope.reloadWireless = function() {
    $scope.wifiConfig = null;
    $scope.wirelessExpanded = true;
    $scope.loadWireless();
  }

  $scope.toggleWirelessExpanded = function() {
    if (!$scope.wirelessExpanded && !$scope.wifiConfig && !$scope.wifiConfigInFlight) {
      $scope.loadWireless();
    }
    $scope.wirelessExpanded = !$scope.wirelessExpanded
  }

  $scope.setPlatformOption = function(boxcaster, platformOption){
    let newValue = prompt("Enter new platform option value:", (platformOption.value || ''));
    if (newValue != null) {
      if (newValue.length === 0) { newValue = null; }
      $scope.platformOption = null;
      return RPC.call($scope.boxcasterId, {request: {message: 'set_key', key: $scope.platformoptKey, value: newValue}}).then(function(data){
        if (data.error != null) {
          $log.error(data);
          return $window.alert("There was an error processing the set_key RPC. Check the console for more details.");
        } else {
          return $scope.platformOption = data;
        }
      });
    }
  };

  $scope.hasEdid = boxcaster => (boxcaster.id != null) && ($scope.isPro(boxcaster) || $scope.isVision(boxcaster)) && (boxcaster.firmware_revision != null) && (boxcaster.firmware_revision >= EDID_FIRMWARE_REVISION);

  $scope.hasRpc = function(boxcaster) {
    if ((boxcaster.id != null) && ($scope.isPro(boxcaster) || $scope.isVision(boxcaster))) {
      return true;
    } else {
      return (boxcaster.firmware_revision != null) && (boxcaster.firmware_revision >= RPC_FIRMWARE_REVISION);
    }
  }

  $scope.hasWifi = boxcaster=> (boxcaster != null) && (boxcaster.id != null) && (boxcaster.id.match(/^[opv]/) != null) && $scope.hasRpc(boxcaster);

  $scope.isConnectedToSsid = (config, ssid)=> (config != null) && (config.scan_results != null) && ((_.find(config.scan_results, r => (r.ssid === ssid) && r.connected)) != null);

  $scope.isConfiguredNetwork = (config, ssid) => _.findWhere(config.current.networks, {ssid: ssid}) != undefined;

  $scope.reduceScanResults = function(scanResults) {
    var map = {};
    _.each(scanResults, function(r) {
      if (map[r.ssid] == undefined || map[r.ssid].signal_strength < r.signal_strength) {
        map[r.ssid] = r;
      }
    });
    var results = [];
    _.each(map, (v) => results.push(v));
    return _.sortBy(results, (i) => i.ssid.toLowerCase());
  };

  // TODO: replace with filter?
  $scope.getStatusWarning = function(boxcaster){
    if (boxcaster.status === 'offline') {
      if (Date.now() >= boxcaster.next_broadcast_at) {
        return 'offline (missing_broadcast)';
      } else {
        return 'offline';
      }
    } else if (boxcaster.warning !== 'none') {
      return `${boxcaster.status} (${boxcaster.warning})`;
    } else {
      return boxcaster.status;
    }
  };

  $scope.editInventory = boxcaster=>
    $modal.open({template: require('./boxcaster_inventory_form.html'), controller: 'BoxcasterInventoryFormController', size: 'lg', backdrop: 'static'}).result.then(editedBoxCaster=> $scope.boxcaster = editedBoxCaster)
  ;

  return $scope.edit = boxcaster=>
    $modal.open({template: require('./boxcaster_form.html'), controller: 'BoxcasterFormController', size: 'md', backdrop: 'static'}).result.then(editedBoxCaster=> $scope.boxcaster = editedBoxCaster)
  ;
});




// WEBPACK FOOTER //
// ./views/boxcaster/boxcaster_controller.js